import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { slugify } from "../utility/slugify";
import { getImageUrl } from "../utility/imageHelper";
import { useAnalytics } from "../context/AnalyticsProvider";   // ✅ Add analytics
import "./styles/SimilarProducts.css";

const SimilarProducts = ({ product }) => {
  const { products } = useStore();
  const analytics = useAnalytics(); // ✅ initialize tracker

  const finalProducts = useMemo(() => {
    if (!product || products.length === 0) return [];

    const currentId = product.id;
    const otherProducts = products.filter(
      (p) => p.id !== currentId && p.stock > 0 // ❗ exclude sold out
    );

    const shuffle = (arr) => [...arr].sort(() => Math.random() - 0.5);

    const sameCategory = otherProducts.filter(
      (p) => p.category_id === product.category_id
    );

    let selected = shuffle(sameCategory);

    if (selected.length < 4) {
      const needed = 4 - selected.length;

      const fallback = shuffle(
        otherProducts.filter((p) => !selected.includes(p))
      ).slice(0, needed);

      selected = [...selected, ...fallback];
    }

    if (selected.length < 3) return [];

    return selected.slice(0, 4);
  }, [product, products]);


  // Detect duplicate names globally
  const nameCounts = products.reduce((acc, p) => {
    acc[p.name] = (acc[p.name] || 0) + 1;
    return acc;
  }, {});

  const duplicateNames = new Set(
    Object.entries(nameCounts)
      .filter(([_, count]) => count > 1)
      .map(([name]) => name)
  );

  if (finalProducts.length < 3) return null;

  return (
    <div className="similar-products-wrapper">
      <h3>Customers Also Viewed</h3>

      <div className="similar-products-grid">
        {finalProducts.map((item, index) => (
          <Link
            key={item.id}
            to={`/shop-knives/knife/${item.id}/${slugify(item.name)}`}
            className="similar-product-card"
            onClick={() => {
              analytics.track("select_item", {
                item_list_name: "Similar Products",
                items: [
                  {
                    item_id: item.id,
                    item_name: item.name,
                    price: item.price,
                    category: item.category_name,
                    stock_remaining: item.stock,
                    index: index + 1,
                  },
                ],
              });
            }}
          >
            <img src={getImageUrl(item.images[0])} alt={item.name} />
            <h3>
              {item.name}
              {duplicateNames.has(item.name) && (
                <> <span className="similar-item-id">(#{item.id})</span></>
              )}
            </h3>
          </Link>
        ))}
      </div>

      <div className="similar-products-footer">
        <p>
          Looking for something else?{" "}
          <Link to="/shop-knives/all-knives" className="similar-products-link">
            Browse all knives →
          </Link>
        </p>
      </div>
    </div>
  );
};

export default SimilarProducts;